<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="SeconDeltaSolSlt_1d00_P31"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import SeconDeltaSolSlt_1d00_P31 from '@/device-products/SeconDeltaSolSlt_1d00_P31.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: SeconDeltaSolSlt_1d00_P31, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
